import React from "react";

import { IProps } from "./types";
import * as S from "./styles";
import { Table } from "react-bootstrap";
import { getPrice, getPriceWithFraction } from "@utils";


const OrderPaymentDetail: React.FC<IProps> = ({
  discount,
  deliveryCharge,
  point,
  voucher,
  subtotal,
  earnPointAmount,
  codChargeTotal,
}: IProps) => {
  return (
    <S.Wrapper>
      <S.OrderPaymentDetailCard>
        <S.OrderPaymentDetailHeader>
          <S.OrderPaymentDetailP>
            Payment Details
          </S.OrderPaymentDetailP>
        </S.OrderPaymentDetailHeader>
        <S.OrderPaymentDetailBody>
          <Table borderless={true} size="sm">
            <tbody>
              { discount > 0 ? 
                <tr>
                  <S.Discount>Discount</S.Discount>
                  <S.TableItemRightDiscount>-{getPrice(discount, true)}</S.TableItemRightDiscount>
                </tr> : <></>
              }
              <tr>
                <S.Td>Delivery Charge</S.Td>
                <S.TableItemRight>{getPrice(deliveryCharge, true)}</S.TableItemRight>
              </tr>
              <tr>
                <S.Td>COD Charge</S.Td>
                <S.TableItemRight>{getPriceWithFraction(codChargeTotal, true, false)}</S.TableItemRight>
              </tr>
              {
                point > 0 ?
                <tr>
                  <S.Discount>Point</S.Discount>
                  <S.TableItemRightDiscount>-{getPrice(point, true)}</S.TableItemRightDiscount>
                </tr> : <></>
              }
              {
                voucher ?
                <tr>
                  <S.Discount>Voucher</S.Discount>
                  <S.TableItemRightDiscount>
                    {/* voucher 할인금액은? */}<br/>
                    {voucher.name}
                  </S.TableItemRightDiscount>
                </tr> : <></>
              }
            </tbody>
          </Table>
          <S.Hr/>
          <Table borderless={true} size="sm">
            <tbody>
              <tr>
                <S.Td>
                  Subtotal<br/>
                  <S.TextMuted>All Taxes Included</S.TextMuted>
                </S.Td>
                <S.TableItemRight>{getPrice(subtotal, true)}</S.TableItemRight>
              </tr>
            </tbody>
          </Table>
          {
            earnPointAmount > 0 ? 
            <>
              <S.Hr/>
              <Table borderless={true} size="sm">
                <tbody>
                  <tr>
                    <S.Td>
                      Point reward
                    </S.Td>
                    <S.TableItemRightPoint>{earnPointAmount}</S.TableItemRightPoint>
                  </tr>
                </tbody>
              </Table>
            </> : <></>
          }
        </S.OrderPaymentDetailBody>
      </S.OrderPaymentDetailCard>
    </S.Wrapper>
  )
};

export { OrderPaymentDetail }